<template>
    <div class="m-panel">
        <div class="m-panel-bar">
            <div class="m-panel-bar-title">
                {{title}}
            </div>
        </div>
        <div class="m-panel-body">
            <div class="base-box">
              <div class="base-item" v-for="item in list">
                <div class="base-img"><img src="@/assets/images/menu-yw.png" alt="" /></div>
                <div class="base-text">
                  <div>{{item.text}}</div>
                  <div><i>{{item.num}}</i></div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getAction,postAction } from '@/api/manage'
export default {
    data() {
        return{
            title: this.$t('基本信息'),
            url:{
              queryBasicInformation: "/jeecg-engineering/ticket/index/largeScreen/queryBasicInformation"
            },
            list:[
              {text:this.$t('本月工单(件)'),num:0},
              {text:this.$t('本周工单(件)'),num:0},
              {text:this.$t('昨日工单(件)'),num:0},
              {text:this.$t('待处理工单(件)'),num:0},
            ],
        }
    },
    mounted() {
    },
    methods: {
        init() {
          this.getData();
        },
        getData(){
          postAction(this.url.queryBasicInformation,{}).then(res=>{
            if(res.success){
              var data = res.result;
              this.list[0].num = data.monthTicketsNum;
              this.list[1].num = data.weekTicketsNum;
              this.list[2].num = data.lastDayTicketsNum;
              this.list[3].num = data.toTicketsNum;
            }
          })
        }
    },
}
</script>
<style lang="less" scoped>
  .base-box{
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    .base-item{
      display: flex;
      align-items: center;
      width: 50%;
      height: 80px;
      .base-img{
        width: 50px;
        height: 50px;
        margin-right: 25px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .base-text{
        color: #fff;
        font-size: 15px;
      }
    }
  }
</style>